import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { getMarca } from "../../services/MarcasService";
import BreadcrumbCRM from "./BreadcrumbCRM";
import { Col, Row, Button, InputGroup, Form } from "react-bootstrap";
import { getReseniaMarca } from "../../services/CRMService";
import MaoTable from "../common/MaoTable";
import { getTableClassNameFromCantidadDias } from "../../utils/SemafoUtil";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "../../utils/NumberUtils";

export default function ReseniaMarca() {

    const {id} = useParams();

    const navigate = useNavigate();

    const [errores, setErrores] = useState([]);
    
    const [datos, setDatos] = useState([]);
    const [marca, setMarca] = useState({});

    const columnas = [
        {
            titulo:"Cliente",
            atributo:"cliente",
            className:"text-truncate max-width-20-em"
        },
        {
            titulo:"Última Compra",
            atributo: "fecha_ult_compra",
            className: "max-width-20-em"
        },
        {
            titulo:"Cant. Días",
            atributo: "cantidad_dias",
            className:"col-importe max-width-20-em"
        },
        {
            titulo:"Monto",
            atributo: "monto_ult_compra",
            className:"col-importe max-width-20-em"
        }
    ]

    useEffect(() => {
        const iniciar = async () => {
            setDatos([]);
            let resp = await getMarca(id);
            if (resp.error) {
                setErrores([resp.message]);
            } else {
                setMarca(resp.data);
                actualizar();
            }
        }
        if (id) {
            iniciar();
        }
    }, [id])

    async function actualizar() {
        let resp2 = await getReseniaMarca(id);
        if (resp2.error) {
            let erroresNew = errores.slice(0);
            erroresNew.push(resp2.message);
            setErrores(erroresNew);
        } else {
            resp2.data = resp2.data.map(d => {
                d.fecha_ult_compra = (d.fecha_ult_compra===null)?"Sin datos":d.fecha_ult_compra;
                d.cantidad_dias = (d.cantidad_dias===null)?"Sin datos":d.cantidad_dias;
                d.monto_ult_compra = (d.monto_ult_compra===null)?"Sin datos":formatNumber(d.monto_ult_compra);
                return d;
            });
            setDatos(resp2.data);
        }
    }

    function volver () {
        navigate("/crm/marcas");
    }

    return <>
        <BreadcrumbCRM active="Reseña de Marca" />
        <Form>
            <Row className="align-items-center">
                <Col xs="auto" md="6">
                <InputGroup className="mb-2">
                <Form.Label htmlFor="inlineFormInput" visuallyHidden>
                    Nombre
                </Form.Label>
                <Form.Control
                    id="txtMarca" 
                    value={marca?.nombre}
                    disabled={true}
                />
                <Button id="btnActualizar"onClick={actualizar} >
                    Actualizar
                </Button>
                </InputGroup>
                </Col>
            </Row>
        </Form>
        <MaoTable 
            columnas={columnas} 
            datos={datos} 
            striped={false}
            colId="marca_id"
            colEstado="cantidad_dias"
            tituloPrimary={false}
            getEstado={(estado) => estado}
            getClassNameFromEstado={getTableClassNameFromCantidadDias}>
        </MaoTable>
        <div className="d-flex justify-content-center">
            <Button onClick={volver}>Volver</Button>
        </div>
    </>

}